var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAppConfirmation(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.88233C4 2.84275 4.84275 2 5.88233 2H14.1177C15.1573 2 16 2.84275 16 3.88233V16.1177C16 17.1573 15.1573 18 14.1177 18H5.88233C4.84275 18 4 17.1573 4 16.1177V3.88233ZM5.88233 3.49533C5.66859 3.49533 5.49533 3.66859 5.49533 3.88233V16.1177C5.49533 16.3314 5.66859 16.5047 5.88233 16.5047H14.1177C14.3314 16.5047 14.5047 16.3314 14.5047 16.1177V3.88233C14.5047 3.66859 14.3314 3.49533 14.1177 3.49533H5.88233Z",
    fill: "#676879"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5.5C5 5.08708 5.33474 4.75234 5.74766 4.75234H14.5C14.9129 4.75234 15.2477 5.08708 15.2477 5.5C15.2477 5.91292 14.9129 6.24766 14.5 6.24766H5.74766C5.33474 6.24766 5 5.91292 5 5.5Z",
    fill: "#676879"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.5L9.77319 12.9996",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77165 13L8 10.9383",
    stroke: "#676879",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppConfirmation);
export default __webpack_public_path__ + "static/media/app-confirmation.1f411c5f.svg";
export { ForwardRef as ReactComponent };